import type { CalcKey } from '../locales/keys';
import type { DiscontinuityKind } from '../calc/limit';

export interface LimitPreset {
  id: string;
  labelKey: CalcKey;
  source: string;
  point: number;
  expectedKind: DiscontinuityKind;
}

export const LIMIT_PRESETS: LimitPreset[] = [
  {
    id: 'removable',
    labelKey: 'preset.limit.removable',
    // (x^2 - 1) / (x - 1) = x + 1 for x ≠ 1; limit at 1 is 2 but f(1) is undefined (0/0).
    source: '(x^2 - 1) / (x - 1)',
    point: 1,
    expectedKind: 'removable',
  },
  {
    id: 'jump',
    labelKey: 'preset.limit.jump',
    // sign(x): left limit = -1, right limit = +1, so |L - R| = 2 → jump.
    source: 'sign(x)',
    point: 0,
    expectedKind: 'jump',
  },
  {
    id: 'infinite',
    labelKey: 'preset.limit.infinite',
    // 1/x diverges to ±∞ as x → 0.
    source: '1 / x',
    point: 0,
    expectedKind: 'infinite',
  },
  {
    id: 'oscillating',
    labelKey: 'preset.limit.oscillating',
    // sin(1/x) oscillates infinitely fast as x → 0; no limit exists.
    source: 'sin(1 / x)',
    point: 0,
    expectedKind: 'oscillating',
  },
  {
    id: 'continuous',
    labelKey: 'preset.limit.continuous',
    // sin(x) is continuous everywhere; limit at 0 equals f(0) = 0.
    source: 'sin(x)',
    point: 0,
    expectedKind: 'continuous',
  },
];
